// extracted by mini-css-extract-plugin
module.exports = {"privacy":"TermsOfUse_privacy__2QZyU"};